import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, setDoc, doc, updateDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDRhmtR_i9DP9fy_dg9KQ28bBTavK02ZWc",
  authDomain: "cosyhole-dev.firebaseapp.com",
  projectId: "cosyhole-dev",
  storageBucket: "cosyhole-dev.appspot.com",
  messagingSenderId: "435594535924",
  appId: "1:435594535924:web:6253d2b578628ca5224fa1"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore and Storage
const db = getFirestore(app);
const storage = getStorage(app);

const auth = getAuth(app);

const uploadImageAndSaveData = async (file, data) => {
  try {
    // Create a storage reference
    const storageRef = ref(storage, `images/${file.name}`);

    // Upload the file
    const snapshot = await uploadBytes(storageRef, file);

    // Get the file's URL
    const downloadURL = await getDownloadURL(snapshot.ref);

    // Add the URL to your data object
    data.imageUrl = downloadURL;

    // Save the data to Firestore
    const docRef = doc(db, 'sections', data.id);
    console.log('data.imageUrl',data.imageUrl);
    await updateDoc(docRef, {imageUrl: data.imageUrl});

    console.log("Document successfully written!");
  } catch (error) {
    console.error("Error writing document: ", error);
  }
};

export { db, collection, getDocs, storage, auth, uploadImageAndSaveData };
